import { Container, Grid } from 'styled-system/jsx'
import { PictureUpload } from './Image/PictureUpload'
import Profile from './Profile'
import Subscription from './Subscription'

export default function () {
	return (
		<Container
			maxW="980px"
			w="100%"
		>
			<Grid
				gridTemplateColumns="1fr 1fr"
				gap={4}
			>
				<Profile />
				<PictureUpload />
				<Subscription />
			</Grid>
		</Container>
	)
}
